import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';

  :global(.RowLink) {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
    width: 100%;

    @include respond-to(md) {
      justify-content: center;
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css`
    :global(.RowLink) {
      color: ${colors.black.hex};
    }
  `;
};

export { staticStyles, getDynamicStyles };
